"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProcurementRequirementStatuses = exports.ProcurementBoxFieldType = exports.ProcurementBoxRangeUnitType = void 0;
/** not source of truth (yet) */
var ProcurementBoxRangeUnitType;
(function (ProcurementBoxRangeUnitType) {
    ProcurementBoxRangeUnitType["Days"] = "Days";
    ProcurementBoxRangeUnitType["Hours"] = "Hours";
    ProcurementBoxRangeUnitType["Meters"] = "Meters";
    ProcurementBoxRangeUnitType["Months"] = "Months";
    ProcurementBoxRangeUnitType["Percents"] = "Percents";
    ProcurementBoxRangeUnitType["SquareMeters"] = "SquareMeters";
    ProcurementBoxRangeUnitType["Years"] = "Years";
})(ProcurementBoxRangeUnitType = exports.ProcurementBoxRangeUnitType || (exports.ProcurementBoxRangeUnitType = {}));
/** not source of truth (yet) */
var ProcurementBoxFieldType;
(function (ProcurementBoxFieldType) {
    ProcurementBoxFieldType["Array"] = "Array";
    ProcurementBoxFieldType["Boolean"] = "Boolean";
    ProcurementBoxFieldType["Date"] = "Date";
    ProcurementBoxFieldType["DateRange"] = "DateRange";
    ProcurementBoxFieldType["Money"] = "Money";
    ProcurementBoxFieldType["MoneyRange"] = "MoneyRange";
    ProcurementBoxFieldType["Number"] = "Number";
    ProcurementBoxFieldType["Range"] = "Range";
    ProcurementBoxFieldType["String"] = "String";
    ProcurementBoxFieldType["Url"] = "URL";
})(ProcurementBoxFieldType = exports.ProcurementBoxFieldType || (exports.ProcurementBoxFieldType = {}));
/** not source of truth (yet) */
var ProcurementRequirementStatuses;
(function (ProcurementRequirementStatuses) {
    ProcurementRequirementStatuses["Info"] = "INFO";
    ProcurementRequirementStatuses["Must"] = "MUST";
    ProcurementRequirementStatuses["Other"] = "OTHER";
    ProcurementRequirementStatuses["Should"] = "SHOULD";
})(ProcurementRequirementStatuses = exports.ProcurementRequirementStatuses || (exports.ProcurementRequirementStatuses = {}));
